module.exports = '<svg width="68" height="32" viewBox="0 0 68 32"><path d="M59.6 8H24V4c0-2.212-2.188-4-4.4-4h-16C1.388 0 0 1.788 0 4v24.5C0 30.712 1.388 32 3.6 32h16c2.212 0 4.4-1.788 4.4-4v-4h7.6l4 4 4-4h4l4 4 4-4h8l8-8-8-8zM16 22a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/key-2.js
// module id = 1201
// module chunks = 14